import styled from 'styled-components';

interface SellTractorImageTooltipProps {
  onButtonClick: () => void;
}

export const SellTractorImageTooltip = ({ onButtonClick }: SellTractorImageTooltipProps) => {
  return (
    <Container>
      <TipText>{'사진 등록 팁 한번 더 체크!'}</TipText>
      <WhiteButton onClick={onButtonClick}>
        <WhiteButtonText>다시 보기</WhiteButtonText>
      </WhiteButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 8px 16px;

  gap: 8px;

  position: absolute;

  top: -60px;
  left: 50%;
  transform: translateX(-50%);

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-offblack, #505363);

  overflow: visible;

  &:after {
    border-top: 6px solid #505363;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 0px solid transparent;
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;

    transform: translate(-50%, 0%);
  }
`;

const TipText = styled.span`
  color: var(--Light-Scheme-Monochrome-white, #fff);

  /* Display/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 18.2px */

  white-space: nowrap;
`;

const WhiteButton = styled.button`
  height: 22px;
  padding: 6px 8px;

  display: flex;
  align-items: center;

  gap: 2px;

  border-radius: var(--radius-small, 4px);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const WhiteButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);
  text-align: center;

  /* System/Small/s-medium */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 10.2px */

  white-space: nowrap;
`;
